import Keycloak from "keycloak-js";

const ADMIN_ROLE = "iyp-admin";

const keycloak = new Keycloak({
  // ponytail: one host serves the SPA and Keycloak, so the origin is the config.
  // Only holds while the chart's keycloak.path is /auth; serve it from the backend if that varies.
  url: process.env.VUE_APP_KEYCLOAK_URL || window.location.origin + "/auth",
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
});

export async function initKeycloak() {
  await keycloak.init({ onLoad: "login-required", pkceMethod: "S256", checkLoginIframe: false });

  keycloak.onTokenExpired = () => keycloak.updateToken(30);
  // Safety net alongside onTokenExpired, which can be unreliable across backgrounded tabs.
  setInterval(() => keycloak.updateToken(70), 60000);

  return keycloak;
}

export function getToken() {
  return keycloak.token;
}

export function getUsername() {
  return keycloak.tokenParsed && keycloak.tokenParsed.preferred_username;
}

export function getRoles() {
  return (keycloak.tokenParsed && keycloak.tokenParsed.realm_access && keycloak.tokenParsed.realm_access.roles) || [];
}

export function getGroups() {
  return (keycloak.tokenParsed && keycloak.tokenParsed.groups) || [];
}

export function hasRole(role) {
  return getRoles().indexOf(role) !== -1;
}

export function isAdmin() {
  return hasRole(ADMIN_ROLE);
}

/** Forces a refresh and reports whether a usable token is now available. */
export async function refreshToken() {
  try {
    await keycloak.updateToken(-1);
    return true;
  } catch (e) {
    return false;
  }
}

export function login() {
  return keycloak.login();
}

export function logout() {
  return keycloak.logout({ redirectUri: window.location.origin + window.location.pathname });
}

/** For URLs that cannot carry a header: img/video src and the SockJS handshake. */
export function withAuthToken(url) {
  return url + (url.includes("?") ? "&" : "?") + "token=" + getToken();
}

export default keycloak;
